import {
  TextField,
  Button,
  Typography,
  Container,
  Box,
  InputAdornment,
  IconButton
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "../../components/Header";
import getCsrfToken from "../features/get_csrfToken";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function Signup() {
  const [credidentials, setCredidentials] = useState({
    email: "",
    password: "",
    name: "",
    surname: "",
    phone: ""
  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredidentials((prev) => ({
      ...prev,
      [e.target.id]: e.target.value,
    }));
  };

  const validateForm = () => {
    const errors = {};

    if (!credidentials.email || !/\S+@\S+\.\S+/.test(credidentials.email)) {
      errors.email = "Email invalide";
    }

    if (!credidentials.password || credidentials.password.length < 8) {
      errors.password = "8 caractères minimum";
    }

    if (!credidentials.name) {
      errors.name = "Prénom requis";
    }

    if (!credidentials.surname) {
      errors.surname = "Nom requis";
    }

    if (!credidentials.phone || credidentials.phone.length < 6) {
      errors.phone = "Numéro invalide";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    setErrors(formErrors);

    if (Object.keys(formErrors).length > 0) return;

    try {
      const res = await axios.post(
        "https://api.komorotel.com/api/auth/register",
        {
          email: credidentials.email,
          name: credidentials.name,
          surname: credidentials.surname,
          password: credidentials.password,
          phone: credidentials.phone,
        },
        {
          withCredentials: true,
        }
      );

      alert("Vérifiez votre email pour confirmer votre compte");
      navigate(`/login/user/${res.data.user.id}`);

    } catch (err) {
      alert(err.response?.data?.message || "Erreur lors de l'inscription");
    }
  };

  return (
    <>
      <Header disabled />

      <Container maxWidth="sm">
        <Box
          sx={{
            mt: 16,
            p: 5,
            borderRadius: 4,
            backgroundColor: "#fff",
            boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
          }}
        >
          {/* TITLE */}
          <Typography variant="h4" fontWeight="bold" mb={1}>
            Créer un compte
          </Typography>

          <Typography variant="body2" color="text.secondary" mb={3}>
            Rejoignez Komorotel en quelques secondes
          </Typography>

          {/* FORM */}
          <Box component="form" onSubmit={handleSubmit}>

            <TextField
              fullWidth
              label="Email"
              id="email"
              margin="normal"
              value={credidentials.email}
              onChange={handleChange}
              error={!!errors.email}
              helperText={errors.email}
            />

            <TextField
              fullWidth
              label="Téléphone"
              id="phone"
              margin="normal"
              placeholder="+269 356 84 56"
              value={credidentials.phone}
              onChange={handleChange}
              error={!!errors.phone}
              helperText={errors.phone}
            />

            <TextField
              fullWidth
              label="Mot de passe"
              id="password"
              type={showPassword ? "text" : "password"}
              margin="normal"
              value={credidentials.password}
              onChange={handleChange}
              error={!!errors.password}
              helperText={errors.password}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                fullWidth
                label="Prénom"
                id="name"
                margin="normal"
                value={credidentials.name}
                onChange={handleChange}
                error={!!errors.name}
                helperText={errors.name}
              />

              <TextField
                fullWidth
                label="Nom"
                id="surname"
                margin="normal"
                value={credidentials.surname}
                onChange={handleChange}
                error={!!errors.surname}
                helperText={errors.surname}
              />
            </Box>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                py: 1.5,
                borderRadius: 2,
                backgroundColor: "#3A9D23",
                "&:hover": { backgroundColor: "#33891E" },
              }}
            >
              Créer mon compte
            </Button>

          </Box>

          {/* FOOTER */}
          <Typography variant="body2" textAlign="center" mt={3}>
            Déjà un compte ?{" "}
            <a href="/login" style={{ color: "#3A9D23" }}>
              Se connecter
            </a>
          </Typography>

        </Box>
      </Container>
    </>
  );
}